import { render, staticRenderFns } from "./vehicleInOut.vue?vue&type=template&id=22b9a584&scoped=true"
import script from "./vehicleInOut.vue?vue&type=script&lang=js"
export * from "./vehicleInOut.vue?vue&type=script&lang=js"
import style0 from "./vehicleInOut.vue?vue&type=style&index=0&id=22b9a584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b9a584",
  null
  
)

export default component.exports